import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Children, useEffect, useState } from 'react';
import Button from '../Button';
import StackView from '../StackView';
import { useDocumentEvent, useFocus, useHover } from '../hooks';

function EditActions(_ref) {
  var display = _ref.display,
      edit = _ref.edit,
      loading = _ref.loading,
      restProps = _objectWithoutPropertiesLoose(_ref, ["display", "edit", "loading"]);

  var _useFocus = useFocus(),
      focus = _useFocus.focus,
      focusProps = _useFocus.focusProps;

  var _useHover = useHover(),
      hover = _useHover.hover,
      hoverProps = _useHover.hoverProps;

  var _useState = useState(false),
      on = _useState[0],
      setOn = _useState[1];

  var _useState2 = useState(false),
      showCheck = _useState2[0],
      setShowCheck = _useState2[1];

  var toggle = function toggle() {
    return setOn(function (bool) {
      return !bool;
    });
  };

  useEffect(function () {
    if (loading === false) {
      setShowCheck(true);
      setTimeout(function () {
        setShowCheck(false);
      }, 800);
    }
  }, [loading]);
  useDocumentEvent('keydown', function (event) {
    if (on && event.keyCode === 27) {
      setOn(false);
    }
  });
  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal",
    alignment: "center",
    spacing: 1,
    width: "100%",
    onClick: on ? undefined : function () {
      return setOn(true);
    }
  }, focusProps, hoverProps, restProps), Children.toArray(on ? edit : display), /*#__PURE__*/React.createElement(Button, {
    grow: 0,
    title: on ? 'Close' : 'Edit',
    icon: {
      name: showCheck ? 'checkmark' : on ? 'close' : 'pencil',
      color: showCheck ? 'green' : undefined
    },
    tooltip: {
      title: showCheck ? undefined : on ? 'Close' : 'Edit'
    },
    size: "sm",
    variant: "naked",
    onClick: focus || on ? toggle : function () {
      return setOn(true);
    },
    opacity: focus || hover || on ? 1 : 0,
    spinner: on && loading ? {
      color: 'primary'
    } : undefined
  }));
}

export default EditActions;